<template>
    <Layout>
        <Aside />
        <el-main class="main" v-if="userId">
            <router-view />
        </el-main>
    </Layout>
</template>

<script>
import { mapActions } from 'vuex';
import Layout from './layout';
import Aside from './aside';

export default {
    components: { Layout, Aside },
    computed: {
        userId() {
            return this.$store.state.userInfo.userId;
        },
    },
    methods: {
        ...mapActions(['getUserInfo']),
    },
    created() {
        this.getUserInfo();
    },
};
</script>

<style lang="less" scoped>
.main {
    height: calc(100vh - 60px);
    background-color: #fafafa;
}
</style>
